import type CompanySetting from 'tio-common/models/company-setting';

type SsoRedirectSettings = Pick<CompanySetting, 'idProvider'> & {
  ssoAuthUrl?: CompanySetting['ssoAuthUrl'] | null;
};

export const isSafeSsoAuthUrl = (url: string | null | undefined) => {
  if (!url) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.protocol === 'https:') {
      return true;
    }

    return (
      parsedUrl.protocol === 'http:' &&
      ['localhost', '127.0.0.1', '[::1]'].includes(parsedUrl.hostname)
    );
  } catch {
    return false;
  }
};

export const shouldUseSsoRedirect = (
  settings: SsoRedirectSettings | null | undefined,
  forceEmailLogin: boolean | string | null | undefined
) => {
  const ssoAuthUrl = settings?.ssoAuthUrl;
  const idProvider = settings?.idProvider;

  return Boolean(
    !forceEmailLogin && idProvider && idProvider !== 'NONE' && isSafeSsoAuthUrl(ssoAuthUrl)
  );
};
